import React from 'react';

import { useTranslation } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

const PaymentDetails = ({ selectedMethod }) => {
  const translate = useTranslation();

  if (!selectedMethod) {
    return null;
  }

  const processingTimeKey = `pmid_${selectedMethod.id}_deposit_processing_time`;
  const feeKey = `pmid_${selectedMethod.id}_deposit_fee`;

  return (
    <div className="one-step-deposit__payment-details">
      {translate[processingTimeKey] && (
        <div className="one-step-deposit__payment-detail-title">
          <Icon
            className="one-step-deposit__payment-detail-icon"
            height={16}
            name="time"
            width={16}
          />
          <Label className="one-step-deposit__payment-detail-label" message="processing_time" />
        </div>
      )}

      <div className="one-step-deposit__payment-detail-content">
        {translate[processingTimeKey] && (
          <Label className="one-step-deposit__payment-detail-value" message={processingTimeKey} />
        )}
        {translate[feeKey] && (
          <div className="one-step-deposit__payment-fee">
            <Icon
              className="one-step-deposit__payment-detail-icon"
              height={16}
              name="max-bonus"
              width={16}
            />
            <Label className="one-step-deposit__payment-detail-label" message="fee" />
            <Label className="one-step-deposit__payment-detail-value" message={feeKey} />
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentDetails;
